import {NavigationItem} from "../models/navigation-item.model";
import {navigation} from "../../app-navigation";

export class NavigationHelper {
  static findByPath(path: string): NavigationItem | null {
    return this.search(path, navigation);
  }

  private static search(path: string, items: NavigationItem[]): NavigationItem | null {
    let result: NavigationItem | null = null;

    for(let item of items)
    {
      if(item.path == path) {
        result = item;
        break;
      }

      if(item.items) {
        result = this.search(path, item.items);

        if(result != null) {
          break;
        }
      }
    }

    return result;
  }
}
